import { render, staticRenderFns } from "./ViewQrCode.vue?vue&type=template&id=395d1c18&scoped=true&"
import script from "./ViewQrCode.vue?vue&type=script&lang=js&"
export * from "./ViewQrCode.vue?vue&type=script&lang=js&"
import style0 from "./ViewQrCode.vue?vue&type=style&index=0&id=395d1c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d1c18",
  null
  
)

export default component.exports